import { Menu, PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { useMatches } from 'react-router-dom'

import { Brand } from './Brand'
import { NotificationBell } from './NotificationBell'
import { ThemeToggle } from './ThemeToggle'
import { UserMenu } from './UserMenu'
import { ValoresToggle } from './ValoresToggle'

interface TopbarProps {
  /** Mobile: abre a gaveta. */
  onOpenMenu: () => void
  /** Desktop: fixa/minimiza a sidebar. */
  onToggleSidebar: () => void
  sidebarFixada: boolean
}

export function Topbar({ onOpenMenu, onToggleSidebar, sidebarFixada }: TopbarProps) {
  // Rotas (ou módulos inteiros) marcados com handle.valores exibem valores monetários
  // e oferecem o botão "ocultar valores".
  const matches = useMatches()
  const exibeValores = matches.some(
    (match) => (match.handle as { valores?: boolean } | undefined)?.valores,
  )

  return (
    // `safe-area-inset-top`: no iPhone (PWA com `viewport-fit=cover`) a página é desenhada
    // sob a barra de status; o padding empurra o conteúdo para baixo dela. Nos demais é 0.
    <header className="sticky top-0 z-20 border-b border-line bg-surface/95 pt-[env(safe-area-inset-top)] backdrop-blur">
      <div className="flex h-16 items-center gap-3 px-4 sm:px-6">
        <button
          type="button"
          onClick={onOpenMenu}
          aria-label="Abrir menu"
          className="grid size-9 place-items-center rounded-lg text-fg-muted hover:bg-surface-2 lg:hidden"
        >
          <Menu className="size-5" />
        </button>

        <button
          type="button"
          onClick={onToggleSidebar}
          aria-label={sidebarFixada ? 'Minimizar menu' : 'Fixar menu aberto'}
          aria-pressed={sidebarFixada}
          title={sidebarFixada ? 'Minimizar menu' : 'Fixar menu aberto'}
          className="hidden size-9 place-items-center rounded-lg text-fg-muted transition-colors hover:bg-surface-2 hover:text-fg lg:grid"
        >
          {sidebarFixada ? (
            <PanelLeftClose className="size-5" />
          ) : (
            <PanelLeftOpen className="size-5" />
          )}
        </button>

        <div className="lg:hidden">
          <Brand markOnly size="sm" />
        </div>

        {/* Busca global — placeholder até existir endpoint de busca */}
        {/* <div className="relative hidden max-w-md flex-1 lg:block">
          <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-fg-subtle" />
          <input
            type="search"
            disabled
            placeholder="Buscar… (em breve)"
            className="h-9 w-full rounded-lg border border-line bg-surface-2 pl-9 pr-3 text-sm text-fg placeholder:text-fg-subtle"
          />
        </div> */}

        <div className="ml-auto flex items-center gap-1">
          {exibeValores && <ValoresToggle className="mr-1" />}
          <NotificationBell />
          <ThemeToggle />
          <div className="mx-1 h-6 w-px bg-line" />
          <UserMenu />
        </div>
      </div>
    </header>
  )
}
